const setCorrectRate = ({ answerCorrectRate, answerCorrectNum, answerReceived }) => {
  const appendStr = `(${answerCorrectNum === -1 ? '--' : answerCorrectNum}/${answerReceived === -1 ? '--' : answerReceived})`
  if (answerCorrectRate >= 0) {
    return `${answerCorrectRate}%` + appendStr
  }
  return '--%' + appendStr
}

const setDaysMonths = ({ phase, phaseName, refuseTimes, score }) => {
  const num = refuseTimes > 0 ? `(打回${refuseTimes}次)` : ''
  if (phase > 0) {
    return `${score > 0 ? score : '--'}分` + `/${phaseName}` + num
  }
  return `--分/` + '--' + num
}

const setBook = ({ phase, phaseName, refuseTimes }) => {
  const num = refuseTimes > 0 ? `(打回${refuseTimes}次)` : ''
  if (phase > 0) {
    return phaseName + num
  }
  return '--' + num
}

const setNotes = ({ phase, phaseName, refuseTimes }) => {
  const num = refuseTimes > 0 ? `(打回${refuseTimes}次)` : ''
  if (phase > 0) {
    return phaseName + num
  }
  return '--' + num
}

module.exports = {
  setCorrectRate,
  setDaysMonths,
  setBook,
  setNotes
}